import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons'
import './styles.css';

const antIcon = <LoadingOutlined style={{ fontSize: 100, color: '#7078b8' }} spin />;

const LoadingPage = () => {
    return (
        <div className="SpinCont">
            <Spin size="large" indicator={antIcon}/>
        </div>
    );
};

LoadingPage.propTypes = {
    
};

export default LoadingPage;